import { Pipe, PipeTransform } from '@angular/core';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ApiServer } from '../models/Profile.model';
import { StateService } from '../state/state.service';

@Pipe({
    name: 'game',
    standalone: false
})
export class GamePipe implements PipeTransform {
  constructor(private state: StateService) {}

  transform(gameName: string) {
    const res = this.state.select<ApiServer>('selectedServer').pipe(
      debounceTime(1),
      map((server) => server?.game),
      distinctUntilChanged(),
      // tslint:disable-next-line: triple-equals
      map((game) => game == gameName)
    );
    return res;
  }
}
